import { func, bool } from 'prop-types'
import { Button, kuiperClassNames, RadioArray } from '@opallabs/kuiper'

import './styles.scss'

function getApprovalsNeededOptions() {
  const options = [
    {
      label: 'All',
      value: true,
    },
    {
      label: 'One',
      value: false,
    },
  ]

  return options
}

function getPhaseStartOptions() {
  const options = [
    {
      label: 'Automatically',
      value: true,
    },
    {
      label: 'Manually',
      value: false,
    },
  ]

  return options
}

const ApprovalsPopoverContent = ({
  autostart,
  locked,
  onChangeApprovalsNeeded,
  onChangePhaseStart,
  onDoneClick,
  requiresAllApprovals,
}) => (
  <div className={kuiperClassNames('approvals-popover-content', 'n1')}>
    <div className={kuiperClassNames('approvals-popover-fieldset')}>
      <div>Approvals Needed:</div>
      <RadioArray
        disabled={locked}
        name="approvals-needed"
        onChange={onChangeApprovalsNeeded}
        options={getApprovalsNeededOptions()}
        value={requiresAllApprovals === null ? false : requiresAllApprovals}
      />
    </div>
    <div className={kuiperClassNames('approvals-popover-fieldset')}>
      <div>This approval phase will start:</div>
      <RadioArray
        name="phase-start"
        onChange={onChangePhaseStart}
        options={getPhaseStartOptions()}
        value={autostart}
      />
      <Button
        onClick={onDoneClick}
        color="blue"
        label="Done"
        type="invisible"
      />
    </div>
  </div>
)

ApprovalsPopoverContent.propTypes = {
  autostart: bool,
  locked: bool,
  onChangeApprovalsNeeded: func,
  onChangePhaseStart: func,
  onDoneClick: func,
  requiresAllApprovals: bool,
}

export default ApprovalsPopoverContent
